import { useMemo } from 'react';
import { useRestaurantMenu } from './RestaurantMenuContext';

export function useKeywordMap(): Map<number, string> {
    const { rawFilterData: { words } } = useRestaurantMenu();

    return useMemo(() => {
        const map = new Map<number, string>();

        (words ?? []).forEach(({ id, name }) => {
            if (id) map.set(id, name ?? '');
        });

        return map;
    }, [words]);
}
